import React, { useState, useEffect } from 'react'
import PowerBIReport from "./PowerBIReport";
import TargetReportConfig from '../../config/TargetReport';


const TargetBroadcastEmailReport = (props: any) => {
   const [embedData, setEmbedData] = useState<any>(null);

    useEffect(() => {
        const fetchEmbedData = async () => {
            try {        
                const response = await fetch(
                    TargetReportConfig.apiEndpoints.getTargetBroadcastEmailReport,
                    {
                        method: "GET",
                        headers: {
                            "Content-Type": "application/json",
                        },
                    }
                );
                if (!response.ok) {
                    throw new Error('Failed to fetch Email Broadcast Report');
                }
                const data = await response.json();
                setEmbedData(data);
            } catch (error) {
                console.error('Error fetching Email Broadcast Report:', error);
            }
        };

        fetchEmbedData();
    }, []);

    if (!embedData) {
        return <p>Loading Broadcast Email Report…</p>;
    }

    return <PowerBIReport {...embedData} />;
};
    
    export default TargetBroadcastEmailReport;